<template>
  <div class="about">
    <section class="banner">
      <img src="../assets/image/page-banner.png"/>
      <div class="text">
        <div>
          <P>为企业提供一站式福利解决方案</P>
        </div>
      </div>
    </section>
    <section class="us">
      <div class="center">
        <h3>关于我们</h3>
        <div class="content">
          <p>
            企业福利助手平台隶属于讯康企业管理（上海）有限公司，为讯康控股集团旗下专业的企业健康管理服务公司，
            凭借全球领先的IT平台技术及强大的供应商整合能力为企业提供一站式的福利解决方案。服务内容覆盖
            体检预约、远程诊疗、网上药店、卡券商城、就医协助、水电煤缴费、信用卡还款、保险保障、及各类本地生活服务等。
          </p>
        </div>
      </div>
    </section>
    <section class="dream">
      <div class="center">
        <h3>企业愿景、企业文化</h3>
        <div class="content">
          <ul>
            <li class="lf" v-for="(t, i) in dreamArr" :key="i">
              <img :src="require('@/assets/image/dream'+ (i+1) +'.png')"/>
              <h5>{{t.title}}</h5>
              <p>{{t.text}}</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="honor">
      <div class="center">
        <h3>荣誉与资质</h3>
        <div class="content">
          <ul>
            <li v-for="(t, i) in honorArr" :key="i">
              <figure>
                <img :class="[!!(i & 1) ? 'rt' : 'lf']" :src="require('@/assets/image/honor'+ (i+1) +'.png')"/>
                <figcaption class="img-text" :class="[!!(i & 1) ? 'lf' : 'rt']"><span>{{t}}</span></figcaption>
              </figure>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'About',
  data() {
    return {
      dreamArr: [
        { title: '我们的使命', text: '通过健康的互联网生态环境为人类健康赋能' },
        { title: '我们的愿景', text: '提升国人健康品质促进中国健康产业良性发展' },
        { title: '我们的精神', text: '正直 合作 创新 竞争' },
        { title: '我们的理念', text: '一切以用户价值为依归' }
      ],
      honorArr: [
        '2017年12月，原总后卫生部部长，中国健康促进基金会理事长--白书忠莅临讯康深圳总部指导工作。',
        '2017年腾讯全球合作伙伴大会，讯康荣膺腾讯行政颁发的“最佳项目团队”奖。',
        '2018年4月，著名健康管理专家，解放军空军航空医学研究所所长、研究员--武留信莅临讯康总部。',
        '2018年腾讯微信公开课PRO，为讯康颁发“年度优秀微信生活智慧服务”奖。',
        '2018年12月，中国器官移植发展基金会与讯康达成深度战略合作。'
      ]
    }
  }
}
</script>
<style scoped lang="less">
  .about {
    .banner {
      height: 355px;
      width: 100%;
      overflow: hidden;
      text-align: center;
      position: relative;
      img {
        height: 355px;
        width: 1920px;
        margin: 0 -100%;
      }
      .text {
        position: absolute;
        z-index: 1;
        top: 0;
        width: 100%;
        height: 100%;
        text-align: left;
        color: @white;
        div {
          width: 1200px;
          height: 100%;
          margin: 0 auto;
        }
        p {
          font-size:48px;
          font-family: @PingFangSC-Semibold;
          font-weight:600;
          line-height:67px;
          margin-top: 140px;
        }
      }
    }
    .center {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      text-align: center;
      box-sizing: border-box;
      h3 {
        font-size:30px;
        font-family: @PingFangSC-Semibold;
        font-weight:600;
        color:@text-color;
        line-height:42px;
      }
    }
    .us {
      width: 100%;
      height: 379px;
      .center {
        padding-top: 60px;
        background: url('@{image}us-bg.png') no-repeat 60px center / 1097px 264px;
        .content {
          p {
            width: 832px;
            margin: 55px auto 0px;
            font-size:16px;
            font-family: @PingFangSC-Regular;
            font-weight:400;
            color:@text-color;
            line-height:40px;
            letter-spacing:2px;
          }
        }
      }
    }
    .dream {
      height:556px;
      width: 100%;
      background:rgba(254,249,244,1);
      .center {
        padding-top: 50px;
        h3 {
          margin-bottom: 70px;
        }
        .content {
          width: 1140px;
          margin: 0 auto;
          ul {
            overflow: hidden;
            li {
              width: 185px;
              margin-right: 133px;
              img {
                height: 160px;
                width: 160px;
              }
              h5 {
                font-size:22px;
                font-family: @PingFangSC-Semibold;
                font-weight:600;
                color:@text-color;
                line-height:30px;
                margin: 30px 0px 10px;
              }
              p {
                font-size:16px;
                font-family: @PingFangSC-Regular;
                font-weight:400;
                color:@text-color;
                line-height:22px;
              }
            }
            li:last-child {
              margin-right: 0px;
            }
          }
        }
      }
    }
    .honor {
      height: 1447px;
      .center {
        overflow: hidden;
        h3 {
          margin: 50px 0px;
        }
        .content {
          width: 785px;
          margin: 0 auto;
          ul {
            background: url('@{image}honor-bg.png') no-repeat center center / 38px 1061px;
            li {
              overflow: hidden;
              margin-bottom: 50px;
              height: 202px;
              img {
                height: 202px;
                width: 326px;
              }
              .img-text {
                height: 202px;
                line-height: 202px;
                margin-left: 8px;
                span {
                  display: inline-block;
                  vertical-align: middle;
                  width: 325px;
                  font-size:18px;
                  font-family: @PingFangSC-Regular;
                  font-weight:400;
                  color:@text-color;
                  line-height:34px;
                  text-align: left;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
